<!-- status content start-->
<ion-grid class="ion-no-padding">
  <ion-row>
    <ion-col class="ion-no-padding">
      <div class="panel-border">
        <ion-row>
          <ion-col class="ion-text-center ion-margin-top ion-margin-bottom">
            <ion-label class="panel-label-text">{{ message() }} </ion-label>
          </ion-col>
        </ion-row>
        @if (canShowButton()) {
          <ion-row>
            <ion-col class="ion-text-center ion-margin-bottom">
              <ion-button
                [disabled]="disableForm()"
                (click)="onClick()"
                class="panel-label-text ion-wrap"
                color="primary"
                align-self-center
              >
                <ion-label class="panel-label-text">
                  <small>{{ btnText() }}</small>
                </ion-label>
              </ion-button>
            </ion-col>
          </ion-row>
        }
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
<!-- status content end-->
